import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PasswordresetService } from './passwordreset.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'ngx-alerts';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationsService } from '../validations.service';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.css']
})
export class PasswordresetComponent implements OnInit {

  resetpswForm: any;
  constructor(private spinner: NgxSpinnerService,private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private passwordresetService: PasswordresetService, private routes: Router, private alertService: AlertService, private session: SessionStorageService) { 
  this.resetpswForm = this.formBuilder.group({
    'email': ['', Validators.compose([
      Validators.required,
      Validators.email
    ])],
    'password': ['', [Validators.required,
      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'),
      Validators.minLength(5),Validators.maxLength(12)]],
    'cpassword': ['',Validators.required]
  },{validator: ValidationsService.passwordValidator });
}
  ngOnInit() {
    let code = this.activatedRoute.snapshot.queryParams["st"];
    if(code) {
        this.spinner.show();
        this.passwordresetService.check(code).then((res: any) => {
          this.resetpswForm.controls.email.patchValue(res.username);
          this.spinner.hide();
          this.alertService.success(res.message);
          this.routes.navigate(['/passwordreset'], { queryParams: { 'st': code } });
          }).catch((err: any)  => { this.alertService.danger(err.message)
            this.spinner.hide();
          this.routes.navigate(['/login']);
          });
    }
  }

  reset() {
    if(!this.resetpswForm.valid){
      Object.keys(this.resetpswForm.controls).forEach(field => { 
        const control = this.resetpswForm.get(field);           
        control.markAsDirty({ onlySelf: true }); 
      });
      return;
    }
    this.spinner.show();
    this.passwordresetService.resetpsw(this.resetpswForm.value,this.activatedRoute.snapshot.queryParams["st"]).then((res: any) => {
      this.session.store('semail', this.resetpswForm.value.email);
      this.spinner.hide();
      this.alertService.success(res.message);
      this.routes.navigate(['/login']);
      }).catch((err: any)  => { this.alertService.danger(err.message)
        this.spinner.hide();
      });
  }

}
